export default "__VITE_ASSET__CxnJV9xf__"